export default {
  '百科内容':'百科内容',
  '百科视频':'百科视频',
  '请上传视频':'请上传视频',
  '请上传PDF文件':'请上传PDF文件',
  '预览':'预览',
  '仅支持扩展名pdf：':'50M以内；支持扩展名：.pdf',
  '分类列表':'分类列表',
  '新增分类':'新增分类',
  '新增':'新增',
  '编辑分类':'编辑分类',
  '确认要删除该分类吗？':'确认要删除该分类吗？',
  '分类删除成功！':'分类删除成功！',
  '分类名称':'分类名称',
  '分类名称已存在':'分类名称已存在',
  '一级分类名称':'一级分类名称',
  '二级分类名称':'二级分类名称',
  '编辑分类成功！':'编辑分类成功！',
  '新增分类成功！':'新增分类成功！',
  '资源内容':'资源内容',
  '百科标题':'百科标题',
  '视频列表':'视频列表',
  '支持上传mp4格式':'支持上传mp4格式，最大不超过1G。',
  '视频':'视频',
  '标题':'标题',
  '简介':'简介',
  '添加视频':'添加视频',
  '编辑视频':'编辑视频',
  '添加视频':'添加视频',
  '视频标题':'视频标题',
  '描述':'描述',
  '视频上传中，是否取消？':'视频上传中，是否取消？',
  '确认要删除该视频吗？':'确认要删除该视频吗？',
  '视频删除成功！':'视频删除成功！',
  '序号':'序号',
  '请输入分类名称搜索':'请输入分类名称搜索',
  '导入分类':'导入分类',
  '分类导入完成':'分类导入完成',
  '分类导入模板':'分类导入模板',
}
